<template>
  <div class="form-row form-item">
    <div id="raft-user-groups-wrapper" class="form-group">
      <label v-if="label" :id="fieldData.field_name + '-label'"
        >{{ label }}:</label
      >
      <b-form-select
        :key="selected"
        :disabled="!userUuid || disabled || groupOptions.length < 1"
        :id="fieldData.field_name"
        :class="fieldClass"
        @input="updateValue($event)"
        v-model="selected"
        :required="isRequired"
        :name="fieldData.field_name"
        :options="groupOptions"
      >
        <!-- This slot appears above the options from 'options' prop -->
        <template #first>
          <b-form-select-option :value="null" disabled>
            -- Select a group --
          </b-form-select-option>
        </template>
      </b-form-select>
    </div>
  </div>
</template>

<script>
import { restClient, jsonClient } from "../../lib/raftApi";

export default {
  name: "UserGroups",
  data() {
    return {
      allowedGroupOptions: [],
      memberships: [],
      selected: null,
    };
  },
  props: {
    fieldData: { type: Object, required: true },
    isRequired: { type: Boolean, default: false },
    fieldClass: { type: String, default: "" },
    fieldValue: { type: String, default: null },
    userUuid: { type: String, default: null },
    label: { type: String, default: null },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    updateValue: function (value) {
      const memberships = this.memberships.filter(
        (entity) => entity.entity_uuid === value,
      );
      if (memberships.length) {
        const membership = memberships[0];
        value = {
          field_name: this.fieldData.field_name,
          field_value: {
            type: membership.entity_type + "--" + membership.entity_bundle,
            id: membership.entity_uuid,
          },
        };
        this.$emit("userGroupSelected", value);
      }
      // @todo Error handling needs to happen here.
    },
    fetchUserGroups: async function () {
      const queries = {
        "filter[uid.id]": this.userUuid,
        "filter[state]": "active",
      };
      this.allowedGroupOptions = [];
      const response = await jsonClient
        .get({ path: "/og_membership/default", queries })
        .catch((e) => this.errorEmit(e));
      this.memberships = response.deserialized;
      const nidList = [];
      this.memberships.forEach((membership) => {
        nidList.push(membership.entity_id);
      });
      const options = {
        path: "/node/titles",
        queries: { nids: nidList },
      };
      const data = await restClient
        .get(options)
        .catch((e) => this.errorEmit(e));
      data.nodes.forEach((nodeData) => {
        this.allowedGroupOptions.push(nodeData.nid);
      });
    },
  },
  errorEmit(message, data) {
    console.error(message);
    this.$emit("form-error-message", { message: message, data: data });
  },
  computed: {
    groupOptions: function () {
      if (!this.userUuid) {
        return [];
      }
      const membershipList = [];
      this.memberships.forEach((membership) => {
        if (this.allowedGroupOptions.includes(membership.entity_id)) {
          membershipList.push({
            value: membership.entity_uuid,
            text: membership.entity_label,
          });
        }
      });
      return membershipList;
    },
  },
  watch: {
    userUuid: {
      immediate: true,
      handler(val) {
        if (val) {
          this.fetchUserGroups();
        }
      },
    },
    fieldValue: {
      immediate: true,
      handler(val) {
        if (val) {
          this.selected = val;
          // this.$forceUpdate();
        }
      },
    },
  },
};
</script>

<style scoped></style>
